import { useCallback, useState } from 'react';
import { MatchHistoryRecord } from '../types/darts';
import { clearMatchHistory, deleteMatchRecord, getMatchHistory, replaceMatchHistory } from '../utils/storage';

/** De opgeslagen uitslagen, met verwijderen dat ongedaan gemaakt kan worden. */
export function useHistory() {
  const [history, setHistory] = useState<MatchHistoryRecord[]>(getMatchHistory);

  const refresh = useCallback(() => setHistory(getMatchHistory()), []);

  /** Verwijdert één uitslag; geeft een functie terug die hem terugzet. */
  const remove = (id: string) => {
    const before = getMatchHistory();
    deleteMatchRecord(id);
    refresh();
    return () => {
      replaceMatchHistory(before);
      refresh();
    };
  };

  /** Wist alles; geeft een functie terug die alles terugzet. */
  const clear = () => {
    const before = getMatchHistory();
    clearMatchHistory();
    refresh();
    return () => {
      replaceMatchHistory(before);
      refresh();
    };
  };

  return { history, refresh, remove, clear };
}
